<template>
  <div class="aboutPc">
    <!-- 轮播 -->
    <div class="swiper container">
      <div class="title">业界认可</div>
      <swiper :options="swiperOption">
        <swiper-slide class="swiperSlide" v-for="(item,index) in swiperList" :key="index">
          <img style="width: 520px;height:500px;" :src="item.url">
          <!-- <div class="swiperTxt">
            <p>2021年6月</p>
            <p>2021最佳健康险智能服务平台提供商》栖观资讯</p>
          </div> -->
        </swiper-slide>
      </swiper>
    </div>
    <!-- 优加新闻 -->
    <div class="YJNews backgroundGray">
      <div class="container">
        <div class="title">优加新闻</div>
        <div class="newsCon">
          <div class="newsItem" v-for="(item,index) in newsList" :key="index">
            <img :src="item.imageUrl" />
            <div class="con">
              <div>
                <h3>{{item.title}}</h3>
                <p>{{item.content}}</p>
              </div>
              <div class="tar"><span class="detailBtn" @click="goDetail(item.url)">查看详情</span></div>
            </div>
          </div>
        </div>
        <div class="pagination">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentIndex" :page-sizes="[10, 20, 30, 50, 100]" :page-size="size"
            layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {
    swiper,
    swiperSlide
  } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  let vm = null
  export default {
    components: {
      swiper,
      swiperSlide,
    },
    props: ['newsList', 'totalCount', 'size', 'currentIndex', 'swiperList'],
    data() {
      return {
        swiperCurrentIndex: 0,

        swiperOption: {
          autoplay: {
            disableOnInteraction: false,
            delay: 2000,
          }, //是否自动播放 true 是  false 否
          slidesPerView: 3, //一排展示几个
          effect: 'coverflow', //轮播图的切换效果  coverflow 3D
          centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左。
          spaceBetween: '-10%', //每个轮播图之间设置距离（单位px）。
          loop: true, // 是否循环播放
          coverflowEffect: { //cover flow是类似于苹果将多首歌曲的封面以3D界面的形式显示出来的方式。coverflow效果参数，可选值：
            rotate: 0, //slide做3d旋转时Y轴的旋转角度
            stretch: 10, //每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
            depth: 100, //slide的位置深度。值越大z轴距离越远，看起来越小。
            modifier: 4, //depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显
            slideShadows: false //是否开启slide阴影
          },
          on: {
            slideChange() {
              vm.swiperCurrentIndex = this.activeIndex
              // console.log(this.activeIndex,'activeIndex',vm.swiperCurrentIndex)
            }
          }
        },

      }
    },
    created() {
      vm = this
    },
    watch: {
      swiperCurrentIndex(val) {
        // console.log(val,'watch=====')
      }
    },
    methods: {
      handleSizeChange(size) {
        this.$emit('searchEmit', 'size', size)

      },
      handleCurrentChange(index) {
        this.$emit('searchEmit', 'index', index)
      },
      goDetail(url) {
        window.open(url, '_blank')
      }
    }
  }
</script>

<style lang="less" scoped>
  .backgroundGray {
    background: #F8F9FD;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
  }

  .aboutPc {
    font-size: 14px;
    display: flex;
    flex-direction: column;

    .title {
      width: 100%;
      text-align: center;
      font-size: 40px;
      font-weight: 400;
      margin-bottom: 60px;

      .subTitle {
        color: #FFFFFF;
        opacity: 0.5;
        font-size: 14px;
        font-weight: 300;
      }
    }

    .swiper {
      padding: 140px 0;


      /deep/ .swiper-container {
        width: 100%;
        height: 500px;

        .swiperSlide {
          width: 520px;
          height: 500px;
          position: relative;

          .swiperTxt {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            text-align: center;
            width: 520px;
            margin-bottom: 24px;

            p {
              font-size: 22px;
              font-family: Source Han Sans CN, Source Han Sans CN-6;
              font-weight: 500;
              color: #ffffff;
              line-height: 31px;
            }
          }
        }
      }
    }

    .YJNews {
      padding: 140px 0;

      .newsCon {
        background: #FFFFFF;
        padding: 0 30px;
        border-radius: 8px;

        .newsItem {
          border-bottom: 1px solid #edeff7;
          display: flex;
          padding: 30px 0;

          img {
            width: 336px;
            height: 190px;
            margin-right: 24px;
            border-radius: 6px;
          }

          .con {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            h3 {
              margin: 0;
              font-size: 24px;
              color: #333333;
              line-height: 36px;
              font-weight: normal;
              margin-bottom: 10px;
            }

            p {
              font-size: 16px;
              color: #666666;
              line-height: 26px;
              font-family: SourceHanSansCN, SourceHanSansCN-Normal;
              font-weight: normal;
            }

            .tar {
              text-align: right;
            }

            .detailBtn {
              width: 144px;
              height: 42px;
              line-height: 42px;
              background: #fc8046;
              border-radius: 6px;
              font-size: 16px;
              font-family: SourceHanSansCN, SourceHanSansCN-Medium;
              font-weight: 500;
              text-align: center;
              color: #FFFFFF;
              display: inline-block;
            }
          }

          &:last-child {
            border-bottom: none;
          }

        }
      }

      .pagination {
        margin-top: 20px;
        text-align: right;

        /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
          background: #FE7811;
        }

        /deep/ .el-pager li {
          background: #FFFFFF;
          border: 1px solid #DDDDDD;
        }

        /deep/ .el-pagination.is-background .btn-prev {
          background: #FFFFFF;
          border: 1px solid #DDDDDD;
        }

        /deep/ .el-pagination.is-background .btn-next {
          background: #FFFFFF;
          border: 1px solid #DDDDDD;
        }

        /deep/ .el-pagination.is-background .el-pager .number {
          &:hover {
            color: #FE7811;
          }
        }

        /deep/ .el-pagination__editor.el-input .el-input__inner {
          border-color: #DDDDDD;
        }

        /deep/ .el-select .el-input.is-focus .el-input__inner {
          border-color: #DDDDDD;
        }

        /deep/ .el-pagination__sizes .el-input .el-input__inner:hover {
          border-color: #FE7811;
        }

        /deep/ .el-select-dropdown__item.selected {
          color: #FE7811!important;
        }
      }
    }
  }
</style>
<style lang="less">
  .el-select-dropdown__item.selected {
    color: #FE7811!important;
  }

  .el-pagination .el-select .el-input .el-input__inner {
    border-color: #DDDDDD!important;
  }
</style>


// WEBPACK FOOTER //
// src/views/pc/newsPc.vue